/**
 * User feed API – all endpoints used by feed pages.
 * Base path: /org/userfeed (user feed routes mounted in backend userRoutes).
 */
import { GET, POST, PUT, DELETE, UPLOAD_FILE, UPLOAD_FILE_WITH_METHOD } from '../apiController';

const ORG_USER_FEED = '/user/userfeed';

// Create a new post (text + optional media)
export const createPost = async (postData) => {
  const formData = new FormData();

  if (postData?.description) formData.append('description', postData.description);
  if (postData?.media?.file) formData.append('media', postData.media.file);

  formData.append('domain', window.location.origin);
  return UPLOAD_FILE(`${ORG_USER_FEED}/create_post`, formData);
};

// Edit an existing post
export const editPost = async (postId, postData) => {
  const formData = new FormData();

  if (postData?.description) formData.append('description', postData.description);
  if (postData?.media?.file) formData.append('media', postData.media.file);

  formData.append('domain', window.location.origin);
  return UPLOAD_FILE_WITH_METHOD(`${ORG_USER_FEED}/edit_post/${postId}`, formData, 'PUT');
};

// Delete a post
export const deletePost = async (postId) => {
  return DELETE(`${ORG_USER_FEED}/delete_post/${postId}`, {
    domain: window.location.origin,
  });
};

// Get a single post by ID (notification deep links)
export const getPostById = async (postId) => {
  return GET(`${ORG_USER_FEED}/get_post/${postId}`);
};

// Get feeds with pagination
export const getAllFeeds = async (page = 1, limit = 5) => {
  return POST(`${ORG_USER_FEED}/get_all_feeds`, {
    page,
    limit,
    domain: window.location.origin,
  });
};

// Get user's own posts (MyFeed)
export const getMyPosts = async (page = 1, limit = 5) => {
  return POST(`${ORG_USER_FEED}/get_all_feeds`, {
    page,
    limit,
    user_only: true,
    domain: window.location.origin,
  });
};

// Toggle like on a post
export const toggleLike = async (postId) => {
  return POST(`${ORG_USER_FEED}/toggle_like/${postId}`, {
    domain: window.location.origin,
  });
};

// Comments
export const addComment = async (postId, comment) => {
  return POST(`${ORG_USER_FEED}/add_comment/${postId}`, {
    comment,
    domain: window.location.origin,
  });
};

export const editComment = async (commentId, comment) => {
  return PUT(`${ORG_USER_FEED}/edit_comment/${commentId}`, {
    comment,
    domain: window.location.origin,
  });
};

export const deleteComment = async (commentId) => {
  return DELETE(`${ORG_USER_FEED}/delete_comment/${commentId}`, {
    domain: window.location.origin,
  });
};

export const getPostComments = async (postId, page = 1, limit = 10) => {
  return GET(`${ORG_USER_FEED}/get_comments/${postId}?page=${page}&limit=${limit}`);
};

// Share
export const generatePostShareUrl = async (postId) => {
  return POST(`${ORG_USER_FEED}/generate_share_url`, {
    post_id: postId,
    domain: window.location.origin,
  });
};

// Public post details (no auth)
export const getPublicPostDetails = async (data) => {
  return POST(`${ORG_USER_FEED}/get_public_post_details`, data);
};
